import { createRouter, createWebHistory } from "vue-router"
import LayoutView from "@/apps/recruiter/views/LayoutView.vue"
import LoginView from "@/apps/recruiter/views/LoginView.vue"
import userRepository from "@/apps/recruiter/repositories/UserRepository"
import route from "@/apps/recruiter/router/route"
import { baseRoutes } from "@/common/router/baseRoutes"
import requireAuth from "@/common/router/requireAuth"
import guard from "@/common/router/guard"
import requireUserType from "@/common/router/requireUserType"
import requireConfig from "@/common/router/requireConfig"
import requireRoot from "@/apps/recruiter/router/requireRoot"

const auth = requireAuth({ fallBackRoute: route.login, fetchUser: userRepository.get })
const root = requireRoot()
const userType = requireUserType()
const config = requireConfig()

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
        {
            ...route.root,
            component: LayoutView,
            meta: {
                middleware: [auth, root, userType, config]
            },
            children: [
                {
                    ...route.vacancies,
                    component: () => import("@/apps/recruiter/views/vacancies/VacanciesView.vue")
                },
                {
                    ...route.vacancy,
                    component: () => import("@/apps/recruiter/views/vacancy/VacancyEditView.vue")
                },
                {
                    ...route.result,
                    component: () =>
                        import("@/apps/recruiter/views/vacancy-result/VacancyResultView.vue")
                },
                {
                    ...route.candidates,
                    component: () => import("@/apps/recruiter/views/CandidatesView.vue")
                },
                {
                    ...route.candidate,
                    component: () => import("@/apps/recruiter/views/candidate/CandidateView.vue")
                },
                {
                    ...route.interviewRequests,
                    component: () =>
                        import(
                            "@/apps/recruiter/views/interview-requests/InterviewRequestsView.vue"
                        )
                },
                {
                    ...route.interviewRequestReports,
                    component: () =>
                        import(
                            "@/apps/recruiter/views/interview-requests-reports/InterviewRequestsReportsView.vue"
                        )
                },
                {
                    ...route.personnelOfficers,
                    component: () =>
                        import(
                            "@/apps/recruiter/views/personnel-officers/PersonnelOfficersView.vue"
                        )
                },
                {
                    ...route.testings,
                    component: () => import("@/apps/recruiter/views/testings/TestingsView.vue")
                }
            ]
        },
        {
            ...route.login,
            component: LoginView
        },
        ...baseRoutes
    ]
})

router.beforeEach(guard())

export default router
